import { useQuery } from '@tanstack/react-query';
import { getProductsByIds } from '@util/firestore/products';
import { getProductLight } from '@util/firestore/products/products.helpers';
import { getUsersViewedProducts } from '@util/firestore/users';
import { useAuth } from 'context/AuthContext';
import { ProductLight } from 'models/product';

const useRecentlyViewed = () => {
  const { user } = useAuth();
  const { data: recentlyViewedProducts = [], isLoading: isLoadingQuery } =
    useQuery({
      queryKey: ['recentlyViewedProducts', user?.uid ?? ''],
      queryFn: async () => {
        if (!user?.uid) return [];
        const views = await getUsersViewedProducts(user.uid);
        if (!views.length) return [];
        const mostRecentViews = views.slice(-20).reverse();
        const products = await getProductsByIds(mostRecentViews);
        // preserve order of mostRecentViews
        const productsMap = new Map(
          products.map((p) => [p.id, getProductLight(p)])
        );
        return mostRecentViews
          .map((id) => productsMap.get(id))
          .filter((p): p is ProductLight => p !== undefined);
      },
      enabled: !!user?.uid,
    });

  return {
    recentlyViewedProducts,
    isLoading: user === undefined || isLoadingQuery,
  };
};

export default useRecentlyViewed;
